// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"524":"Product","770":"Partners","848":"Register","922":"MyAccount"}[chunkId] || chunkId) + "-legacy." + {"524":"74c37273","770":"9cf2b5db","817":"af49e420","848":"34166d38","922":"efaba391"}[chunkId] + ".js";
};